import { render, staticRenderFns } from "./HowToPlay.vue?vue&type=template&id=e766d2b0&"
import script from "./HowToPlay.vue?vue&type=script&lang=js&"
export * from "./HowToPlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports